import axios from 'axios'


export default axios.create({
    baseURL: 'https://test.alromansiah.com/api/v1',
    headers: {

        'Content-type': 'application/json'
    }
})

export const AxiosProvider2 = axios.create({
    baseURL: 'https://test.alromansiah.com/api/v2',
    headers: {

        'Content-type': 'application/json'
    }
}) 
